import { render, staticRenderFns } from "./BairroSection.vue?vue&type=template&id=a56034be&scoped=true"
import script from "./BairroSection.vue?vue&type=script&lang=js"
export * from "./BairroSection.vue?vue&type=script&lang=js"
import style0 from "./BairroSection.vue?vue&type=style&index=0&id=a56034be&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56034be",
  null
  
)

export default component.exports